<template>
    <div class="main-container">
        <div class="main-header container">
            <ainak-header/>
        </div>
        <div class="main-content container" v-if="this.$store.state.PaymentPortal_linked">
            <profile-content/>
        </div>
        <div class="main-content container" v-else>
            <profile-content-simple/>
            <!-- <profile-content/> -->
        </div>
        <div class="main-footer">
            <ainak-footer/>
        </div>
    </div>
</template>

<script>
    import AinakFooter from "@/components/AinakFooter.vue";
    import AinakHeader from "@/components/AinakHeader.vue";
    import ProfileContent from "@/components/Profile/ProfileContent.vue";
    import ProfileContentSimple from "@/components/Profile/ProfileContentSimple.vue";
    export default {
        name: "Profile",
        data(){
            return {
                data:[]
            }
        },
        components: {
            ProfileContent,
            ProfileContentSimple,
            AinakHeader,
            AinakFooter
        },
        mounted(){
            this.checkifLoggedIn(),
            this.getPaymentPortalData()
        },
        methods: {
            checkifLoggedIn(){
                console.log("loggedin: ",this.$store.state._user_authenticated);
                if(!this.$store.state._user_authenticated){
                    this.$router.push('Login');
                }
            },

            getPaymentPortalData(){
                console.log("tried");
                if(this.$store.state.PaymentPortal_SubscriptionObject.length === 0){
                    this.$store.dispatch('PaymentPortal_get_customer_list')
                    .then(() => { 
                            console.log("Payment Portal Linked");})
                    .catch(() => {

                        console.log("Payment Portal NOTLinked");
                    })
                }
            },

        }
    }
</script>

<style  lang="scss" scoped>
    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }
    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .main-container {
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "main-header" "main-content" "main-footer";
        grid-template-rows: 10% 85% 5%;
        grid-template-columns: 1fr;
        overflow: hidden;
        margin:  0;

        .main-header {
            @extend %flex-center-content;
        }

        .main-content {
            grid-area: main-content;
            background-color: $bg-color;
            @extend %top-padding-width-height;
            overflow: hidden;
        }

        .main-footer{
            grid-area: main-footer;
            display: flex;
            justify-content: center;
            flex-direction: column;
            background-color: #f5f5f5;
        }
    }

</style>